import React, { Component } from "react"
import { v4 as uuidv4 } from 'uuid';
import { ListGroup, Card } from "react-bootstrap"
import {
	getQuestionByCategory,
	getAllQuestion,
	addCommentsToQuestions,
	getUserByToken,
} from "../../services/Api"
import "../BodyContent.scss"
import "../Responsive.scss"
import { handleUserSetup } from "../../redux/actions/User"
import { MongoTimeConvert } from "../../converters/timeConverters"
import SideBar from "./SideBar"
import { connect } from "react-redux"
import Board from "../../comments/Comments"
import { toast } from "react-toastify"
import QuestionsFeed from "../feed/questions"
import MainLoader from "../loader/MainLoader";

const EDUCATE_TOKEN = "educate_token"
class BodyContent extends Component {
	constructor() {
		super()

		this.state = {
			diplay: "none",
			data: [],
			allQuestions: [],
			loading: true
		}

		this._onKeyUp = (e) => {
			// filter post list by title using onKeyUp function

			console.log(e.target.value)
			console.log(this.state.allQuestions)
			const data = this.state.allQuestions.filter((item) =>
				item.question
					.toLowerCase()
					.includes(e.target.value.toLowerCase())
			)

			this.setState({
				...this.state,
				data
			})
		}
		this.loadNewQuestions = async (params) => {
			const categoryid = {
				id: params,
			}
			const data = await getQuestionByCategory(categoryid)
			console.log(data)

			// console.log(params)
			this.setState({
				...this.state,
				data: data,
				allQuestions: data,
			})
		}
		this.addComments = async (id, comment, userName) => {
			var user = ""
			console.log(this.props.currentUser.fullName)
			if (this.props.currentUser.fullName === undefined && userName) {
				user = userName
			} else if (
				this.props.currentUser.fullName === undefined &&
				!userName
			) {
				user = "Anonymous"
			} else {
				user = this.props.currentUser.fullName
			}

			const commentData = {
				questionId: id,
				user: user,
				comment: comment,
			}

			const commentdata = await addCommentsToQuestions(commentData)
			toast(commentdata.message, { type: "success" })
			this.componentDidMount()
		}
	}

	displayComments(displayComments, id) {
		var newDisplay = ""
		const allquestions = this.state.data
		for (var i = 0; i < allquestions.length; i++) {
			if (allquestions[i]._id === id) {
				if (allquestions[i].displayComments === "block") {
					newDisplay = "none"
				} else {
					newDisplay = "block"
				}
				allquestions[i].displayComments = newDisplay
			}
		}

		this.setState({
			...this.state,
			data: allquestions,
		})
	}

	async checkLogedIn() {
		if (localStorage.getItem(EDUCATE_TOKEN)) {
			const user = await getUserByToken()
			this.props.dispatch(handleUserSetup(user.user))
			this.setState({
				...this.state,
				user: true,
				displayButtons: "block",
			})
		} else {
			console.log("User not logged in")
		}
	}

	async componentDidMount() {
		this.checkLogedIn()
		const questions = await getAllQuestion()
		console.log(questions )
		this.setState({
			...this.state,
			data: questions,
			allQuestions: questions,
			loading: false
		})
	}

	render() {
		return (
			<React.Fragment>
				<MainLoader loading={this.state.loading} />
				{/* <Header OnSearch={this._onKeyUp} /> */}
				<div className='contentDiv'>
					<div className='col-lg-2' id="sidebarContent">
						<SideBar LoadQuestion={this.loadNewQuestions} />
					</div>
					<div className='col-lg-6'>
						<div className='middleSection'>
							<div className='generalQuestion'>
							View questions below
							</div>

						</div>
						{this.state.data != null && this.state.data.map((item) => (
							<div key={uuidv4()} className='questionsCard'>
								<Card>
									<Card.Body>
										<Card.Header>
											<div className='headerStructure'>
												<div className='userNameAndIcon'>
													<div className='imageIcon'>
														<img alt='User Icon'
															src={require("../../icons/iconuser.png")}
														/>
													</div>
													<div className='ownerName'>
														{item.user ===null?<div> Anonymous</div> :  item.user.fullName}
														<span>
															{" "}
															{MongoTimeConvert(
																item.createdAt
															)}
														</span>{" "}
													</div>
												</div>

	
											</div>
										</Card.Header>
										<Card.Text>{item && item.question}</Card.Text>
									</Card.Body>

									<div>
										<div className='commentIcon'>
											<div
												onClick={() =>
													this.displayComments(
														item.displayComments,
														item._id
													)
												}
												className='imageIcon'
											>
												<img alt='comments outlined'
													className='cardIcon'
													src={require("../../icons/comment-outlined.svg")}
												/>
												<span>
													{item && item.comments.length}
												</span>
											</div>
	
										</div>
									</div>
									<div>
										<div
											style={{
												display: item.displayComments || false,
											}}
										>
											<Board
												userComment={item.comments}
												question={item._id}
												addComments={this.addComments}
											/>
										</div>
									</div>
								</Card>
							</div>
						))}
					</div>
					<div className='col-lg-2' id='improve-your-feed'>
						<div className='middleSection'>
							<ListGroup>
								<ListGroup.Item className='listFirstItem feedCateGoryName'>
									Improve Your feed{" "}
								</ListGroup.Item>
								<QuestionsFeed />
							</ListGroup>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(BodyContent)
